import { API } from '@/config/api.js'
const seo_blocked = ['/admin', '/login', '/settings', '/json-editor'];

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    error: null,
    statistic: null,
    sessionUid: null,
    requests: null, // <- добавлено
  }),
  getters: {
    loading: state => state.loading,
    error: state => state.error,
    statistic: state => state.statistic,
    sessionUid: state => state.sessionUid,
    requests: state => state.requests, // <- добавлено
  },
  mutations: {
    SET_LOADING(state, value) { state.loading = value },
    SET_ERROR(state, value) { state.error = value },
    SET_SESSION_UID(state, uid) { state.sessionUid = uid },
    SET_STATISTIC(state, data) { state.statistic = data },
    SET_REQUESTS(state, data) { state.requests = data }, // <- добавлено
  },
  actions: {
    async START_STATISTIC({ commit, rootState }, data = {}) {
      if (seo_blocked.includes(window.location.pathname)) {
        return;
      }

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const ua = navigator.userAgent || '';
        const language = navigator.language || navigator.userLanguage || null;
        const screen_width = window.screen ? window.screen.width : null;
        const screen_height = window.screen ? window.screen.height : null;
        const viewport_width = document.documentElement.clientWidth || window.innerWidth;
        const viewport_height = document.documentElement.clientHeight || window.innerHeight;
        const referrer = document.referrer || null;
        const entry_url = window.location.href;
        const entry_time = new Date().toISOString();
        const is_mobile = /Mobi|Android/i.test(ua);
        const is_tablet = /Tablet|iPad/i.test(ua);
        const device_type = is_tablet ? 'tablet' : (is_mobile ? 'mobile' : 'desktop');
        const urlParams = new URLSearchParams(window.location.search);
        const utm_source = urlParams.get('utm_source') || null;
        const utm_medium = urlParams.get('utm_medium') || null;
        const utm_campaign = urlParams.get('utm_campaign') || null;

        const payload = {
          user_uid: data.user_uid || null,
          entry_url: data.entry_url || entry_url,
          referrer: data.referrer || referrer,
          entry_time: data.entry_time || entry_time,
          device_type: data.device_type || device_type,
          browser: data.browser || (navigator.appName || ''),
          browser_version: data.browser_version || (navigator.appVersion || ''),
          os: data.os || '',
          os_version: data.os_version || '',
          screen_width: data.screen_width || screen_width,
          screen_height: data.screen_height || screen_height,
          viewport_width: data.viewport_width || viewport_width,
          viewport_height: data.viewport_height || viewport_height,
          is_mobile: data.is_mobile !== undefined ? data.is_mobile : is_mobile,
          language: data.language || language,
          utm_source: data.utm_source || utm_source,
          utm_medium: data.utm_medium || utm_medium,
          utm_campaign: data.utm_campaign || utm_campaign,
          user_agent: data.user_agent || ua,
          landing_settings_uid: data.landing_settings_uid,
          ...data.extra
        };

        const headers = { 'Content-Type': 'application/json' };
        const token = rootState?.auth?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(`${API.fullUrl}/landing/statistic`, {
          method: 'POST',
          headers,
          body: JSON.stringify(payload)
        });

        const json = await res.json().catch(() => null);

        if (!res.ok) {
          const message = (json && (json.message || json.data || json.description)) || `HTTP ${res.status}`;
          commit('SET_ERROR', message);
          throw new Error(message);
        }

        const sessionUid = json.data.uid
        if (sessionUid) commit('SET_SESSION_UID', sessionUid);
        return json.data || null;
      } catch (err) {
        commit('SET_ERROR', err.message || String(err));
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async UPDATE_SESSION_CONVERSESION({ state, commit, rootState }, data = {}) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const session_uid = data.session_uid || state.sessionUid || null;
        if (!session_uid) {
          const msg = 'SEND_SESSION_END: session_uid not found';
          commit('SET_ERROR', msg);
          commit('SET_LOADING', false);
          return null;
        }

        let is_conversion = true
        const payloadObj = { session_uid, is_conversion };

        const headers = { 'Content-Type': 'application/json' };
        const token = rootState?.auth?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(`${API.fullUrl}/landing/statistic/conversioned`, {
          method: 'POST',
          headers,
          body: JSON.stringify(payloadObj),
          keepalive: true
        });

        const json = await res.json().catch(() => null);


        if (!res.ok) {
          const message = (json && (json.message || json.data || json.description)) || `HTTP ${res.status}`;
          commit('SET_ERROR', message);
          throw new Error(message);
        }

      } catch (err) {
        commit('SET_ERROR', err.message || String(err));
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async SEND_SESSION_END({ state, commit, rootState }, data = {}) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const session_uid = data.session_uid || state.sessionUid || null;
        if (!session_uid) {
          const msg = 'SEND_SESSION_END: session_uid not found';
          commit('SET_ERROR', msg);
          commit('SET_LOADING', false);
          return null;
        }

        const exit_time = data.exit_time || new Date().toISOString();
        const payloadObj = { session_uid, exit_time };

        const headers = { 'Content-Type': 'application/json' };
        const token = rootState?.auth?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(`${API.fullUrl}/landing/statistic/end`, {
          method: 'POST',
          headers,
          body: JSON.stringify(payloadObj),
          keepalive: true
        });

        const json = await res.json().catch(() => null);

        if (!res.ok) {
          const message = (json && (json.message || json.data || json.description)) || `HTTP ${res.status}`;
          commit('SET_ERROR', message);
          throw new Error(message);
        }

        commit('SET_SESSION_UID', null);
        return json;
      } catch (err) {
        commit('SET_ERROR', err.message || String(err));
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async GET_STATISTIC({ state, commit, rootState }, params = {}) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const { landing_settings_uid } = params;
        if (!landing_settings_uid) {
          commit('SET_LOADING', false);
          return null;
        }

        const qs = new URLSearchParams();
        if (landing_settings_uid) qs.append('uid', landing_settings_uid);

        const url = `${API.fullUrl}/landing/statistic/` + landing_settings_uid;
        const headers = { 'Content-Type': 'application/json' };
        const token = rootState?.auth?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(url, { method: 'GET', headers });
        const json = await res.json().catch(() => null);

        if (!res.ok) {
          const message = (json && (json.message || json.data || json.description)) || `HTTP ${res.status}`;
          commit('SET_ERROR', message);
          throw new Error(message);
        }

        commit('SET_STATISTIC', json.data);
        return json;
      } catch (err) {
        commit('SET_ERROR', err.message || String(err));
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // --- получить все запросы по LANDING_SETTINGS_UID ---
    async GET_REQUESTS_BY_LANDING_SETTINGS_UID({ state, commit, rootState }, params = {}) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const landing_settings_uid = params.landing_settings_uid || state.sessionUid || null;
        if (!landing_settings_uid) {
          const msg = 'GET_REQUESTS_BY_LANDING_SETTINGS_UID: landing_settings_uid not found';
          commit('SET_ERROR', msg);
          commit('SET_LOADING', false);
          return null;
        }

        const headers = { 'Content-Type': 'application/json' };
        const token = rootState?.auth?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const url = `${API.fullUrl}/landing/requests/${encodeURIComponent(landing_settings_uid)}`;
        const res = await fetch(url, { method: 'GET', headers });
        const json = await res.json().catch(() => null);

        if (!res.ok) {
          const message = (json && (json.message || json.data || json.description)) || `HTTP ${res.status}`;
          commit('SET_ERROR', message);
          throw new Error(message);
        }

        // Сохраняем в стор (можно переиспользовать в компонентах)
        commit('SET_REQUESTS', json.data || null);
        return json.data || null;
      } catch (err) {
        commit('SET_ERROR', err.message || String(err));
        return null;
      } finally {
        commit('SET_LOADING', false);
      }
    },

  }
}
